import { create } from "zustand";

const STORAGE_KEY = "foodsight:admin-org";

interface AdminOrgState {
  orgId: string;
  orgName: string;
  siteId: string;
  siteName: string;
  setOrg: (orgId: string, orgName: string) => void;
  clearOrg: () => void;
  setSite: (siteId: string, siteName: string) => void;
  clearSite: () => void;
}

function loadFromStorage(): { orgId: string; orgName: string; siteId: string; siteName: string } {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (raw) {
      const parsed = JSON.parse(raw);
      return {
        orgId: parsed.orgId ?? "",
        orgName: parsed.orgName ?? "",
        siteId: parsed.siteId ?? "",
        siteName: parsed.siteName ?? "",
      };
    }
  } catch {
    // ignore
  }
  return { orgId: "", orgName: "", siteId: "", siteName: "" };
}

function saveToStorage(state: { orgId: string; orgName: string; siteId: string; siteName: string }) {
  if (state.orgId || state.siteId) {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(state));
  } else {
    localStorage.removeItem(STORAGE_KEY);
  }
}

export const useAdminOrgStore = create<AdminOrgState>((set, get) => ({
  ...loadFromStorage(),
  setOrg: (orgId, orgName) => {
    const next = { orgId, orgName, siteId: "", siteName: "" };
    saveToStorage(next);
    set(next);
  },
  clearOrg: () => {
    const next = { orgId: "", orgName: "", siteId: "", siteName: "" };
    saveToStorage(next);
    set(next);
  },
  setSite: (siteId, siteName) => {
    const { orgId, orgName } = get();
    const next = { orgId, orgName, siteId, siteName };
    saveToStorage(next);
    set({ siteId, siteName });
  },
  clearSite: () => {
    const { orgId, orgName } = get();
    const next = { orgId, orgName, siteId: "", siteName: "" };
    saveToStorage(next);
    set({ siteId: "", siteName: "" });
  },
}));
